export const USERDATA = 'USERDATA';
export const SIGNUPDATA = 'SIGNUPDATA';
export const ADDCART = 'ADDCART';
export const DELETECART = 'DELETECART';
export const CLEARCART = 'CLEARCART';
export const ADDORDER = 'ADDORDER';
export const DELETEORDER = 'DELETEORDER';
export const CLEARORDER = 'CLEARORDER';
export const ADDSECRET = 'ADDSECRET';
export const SHOW_LOAD = 'SHOW_LOAD';
export const HIDE_LOAD = 'HIDE_LOAD';
export const SHOPPING_HIDE_LOAD_MOV_CART = 'SHOPPING_HIDE_LOAD_MOV_CART';
export const SHOPPING_SHOW_LOAD_MOV_CART = 'SHOPPING_SHOW_LOAD_MOV_CART';
export const SHOPPING_HIDE_LOAD_DEL_FROM_CART = 'SHOPPING_HIDE_LOAD_DEL_FROM_CART';
export const SHOPPING_SHOW_LOAD_DEL_FROM_CART = 'SHOPPING_SHOW_LOAD_DEL_FROM_CART';
export const SHOPPING_HIDE_LOAD_ADD_TO_CART = 'SHOPPING_HIDE_LOAD_ADD_TO_CART';
export const SHOPPING_SHOW_LOAD_ADD_TO_CART = 'SHOPPING_SHOW_LOAD_ADD_TO_CART';
export const RESTORECART = 'RESTORECART';
export const LOGOUTUSER = 'LOGOUTUSER';
export const ADDTOKENACCESS = 'ADDTOKENACCESS';
export const ADDTOKENAUTH = 'ADDTOKENAUTH';
export const REMOVETOKEN = 'REMOVETOKEN';
